
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:inline-flex;
  border-radius:0.5rem;
  vertical-align:middle;
}
:host([variant='dropdown-nav']){
  width:100%;
}
:host([is-disabled]){
  pointer-events:none;
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.btn{
  display:flex;
  flex-wrap:nowrap;
  align-items:center;
  cursor:pointer;
  position:relative;
  border-radius:9999px;
  transition-property:color, background-color, border-color,
    fill, stroke, -webkit-text-decoration-color;
  transition-property:color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-property:color, background-color, border-color,
    text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:200ms;
  -webkit-text-decoration-line:none;
          text-decoration-line:none;
  outline:2px solid transparent;
  outline-offset:2px;
  font-family:'DM Sans';
}
.btn[aria-disabled='true']{
  pointer-events:none;
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.btn.slim{
  font-size:var(--fs-sm);
  padding:0 2rem;
  height:min-content;
}
@media (max-width: 1023px){
.btn.slim{
    font-size:var(--fs-xs)
}
  }
.btn.small{
  font-size:var(--fs-sm);
  padding:0.5rem 1.25rem;
}
@media (max-width: 767px){
.btn.small{
    font-size:var(--fs-xs);
    padding:0.25rem 0.75rem
}
  }
.btn.medium{
  font-weight:500;
  font-size:var(--fs-xl);
  padding:0.5rem 1.75rem;
}
@media (max-width: 1023px){
.btn.medium{
    font-size:var(--fs-base);
    padding:0.25rem 1.25rem
}
  }
.btn.large{
  font-weight:500;
  font-size:var(--fs-3xl);
  padding:0.75rem 2.25rem;
}
@media (max-width: 767px){
.btn.large{
    font-size:var(--fs-lg);
    padding:0.25rem 1.5rem
}
  }
.btn.primary{
  border:solid 2px var(--brand-primary-1);
  background-color:var(--brand-primary-1);
  color:var(--brand-neutral-white);
}
.btn.primary:hover{
    background-color:var(--brand-neutral-white);
    color:var(--brand-primary-1);
  }
.btn.primary:focus{
    background-color:var(--brand-primary-1);
    color:var(--brand-neutral-white);
  }
.btn.primary:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-primary-1);
    width:calc(100% + 12px);
    height:calc(100% + 12px);
    left:-6px;
    border-radius:9999px;
  }
.btn.primary:active{
    background-color:var(--brand-neutral-gray-900) !important;
    border:2px solid var(--brand-neutral-gray-900) !important;
    color:var(--brand-neutral-white) !important;
  }
.btn.primary:active::after{
      display:none;
    }
.primary[aria-disabled='true']{
  background-color:var(--brand-neutral-gray-600) !important;
  color:var(--brand-neutral-gray-100) !important;
  border:0 !important;
}
.primary[aria-disabled='true']::after{
    border:solid 1px var(--brand-neutral-gray-400) !important;
  }
.btn.primary-2{
  border:solid 2px var(--brand-primary-2);
  background-color:var(--brand-primary-2);
  color:var(--brand-neutral-white);
}
.btn.primary-2:hover{
    background-color:var(--brand-neutral-white);
    color:var(--brand-primary-2);
  }
.btn.primary-2:focus{
    background-color:var(--brand-primary-2);
    color:var(--brand-neutral-white);
  }
.btn.primary-2:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-primary-2);
    width:calc(100% + 12px);
    height:calc(100% + 12px);
    left:-6px;
    border-radius:9999px;
  }
.btn.primary-2:active{
    background-color:var(--brand-neutral-gray-900) !important;
    border:2px solid var(--brand-neutral-gray-900) !important;
    color:var(--brand-neutral-white) !important;
  }
.btn.primary-2:active::after{
      display:none;
    }
.primary-2[aria-disabled='true']{
  background-color:var(--brand-neutral-gray-600) !important;
  color:var(--brand-neutral-gray-100) !important;
  border:0 !important;
}
.primary-2[aria-disabled='true']::after{
    border:solid 1px var(--brand-neutral-gray-400) !important;
  }
.btn.registration{
  border:solid 2px var(--brand-primary-1);
  background-color:var(--brand-primary-1);
  color:var(--brand-neutral-white);
  margin-top:var(--spacing-5);
}
.btn.registration:hover{
    background-color:var(--brand-neutral-white);
    color:var(--brand-primary-1);
  }
.btn.registration:focus{
    background-color:var(--brand-primary-1);
    color:var(--brand-neutral-white);
  }
.btn.registration:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-primary-1);
    width:calc(100% + 12px);
    height:calc(100% + 12px);
    left:-6px;
    border-radius:9999px;
  }
.btn.registration:active{
    background-color:var(--brand-neutral-gray-900) !important;
    border:2px solid var(--brand-neutral-gray-900) !important;
    color:var(--brand-neutral-white) !important;
  }
.btn.registration:active::after{
      display:none;
    }
.registration[aria-disabled='true']{
  background-color:var(--brand-neutral-gray-600) !important;
  color:var(--brand-neutral-gray-100) !important;
  border:0 !important;
}
.registration[aria-disabled='true']::after{
    border:solid 1px var(--brand-neutral-gray-400) !important;
  }
.btn.secondary{
  background-color:var(--brand-neutral-white);
  border:2px solid var(--brand-neutral-white);
  color:var(--brand-neutral-gray-800);
}
.btn.secondary:hover{
    background-color:var(--brand-primary-2);
    color:var(--brand-neutral-white);
  }
.btn.secondary:focus{
    background-color:var(--brand-neutral-white);
    color:var(--brand-neutral-gray-800);
  }
.btn.secondary:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-neutral-white);
    width:calc(100% + 10px);
    height:calc(100% + 10px);
    left:-5px;
    border-radius:9999px;
  }
.btn.secondary:active{
    background-color:var(--brand-neutral-gray-900) !important;
    border:2px solid var(--brand-neutral-gray-900) !important;
    color:var(--brand-neutral-white) !important;
  }
.btn.secondary:active::after{
      display:none;
    }
.secondary[aria-disabled='true']{
  background-color:var(--brand-neutral-gray-600) !important;
  color:var(--brand-neutral-gray-100) !important;
  border:0 !important;
}
.secondary[aria-disabled='true']::after{
    border:solid 1px var(--brand-neutral-gray-400) !important;
  }
.btn.tertiary{
  background-color:var(--brand-neutral-white);
  color:var(--brand-neutral-gray-800);
  border:2px solid var(--brand-neutral-white);
  z-index:2;
}
.btn.tertiary:hover{
    background-color:var(--brand-primary-1);
    color:var(--brand-neutral-white);
  }
.btn.tertiary:focus{
    background-color:var(--brand-neutral-white);
    color:var(--brand-neutral-gray-800);
  }
.btn.tertiary:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-neutral-white);
    width:calc(100% + 10px);
    height:calc(100% + 10px);
    left:-5px;
    border-radius:9999px;
  }
.btn.tertiary:active{
    background-color:var(--brand-primary-3) !important;
    border:2px solid var(--brand-primary-3) !important;
  }
.btn.tertiary:active::after{
      display:none;
    }
.tertiary[aria-disabled='true']{
  background-color:var(--brand-neutral-gray-600) !important;
  color:var(--brand-neutral-gray-100) !important;
  border:0 !important;
}
.tertiary[aria-disabled='true']::after{
    border:solid 1px var(--brand-neutral-gray-400) !important;
  }
.btn.tertiary ::slotted(outline-icon[slot='left']), .btn.secondary ::slotted(outline-icon[slot='left']), .btn.primary ::slotted(outline-icon[slot='left']), .btn.primary-2 ::slotted(outline-icon[slot='left']), .btn.registration ::slotted(outline-icon[slot='left']){
    margin-right:0.5rem;
  }
.btn.tertiary ::slotted(outline-icon[slot='right']), .btn.secondary ::slotted(outline-icon[slot='right']), .btn.primary ::slotted(outline-icon[slot='right']), .btn.primary-2 ::slotted(outline-icon[slot='right']), .btn.registration ::slotted(outline-icon[slot='right']){
    transition-duration:200ms;
    display:flex;
    margin-left:1.5rem;
  }
@media (max-width: 768px){
.btn.tertiary ::slotted(outline-icon[slot='right']), .btn.secondary ::slotted(outline-icon[slot='right']), .btn.primary ::slotted(outline-icon[slot='right']), .btn.primary-2 ::slotted(outline-icon[slot='right']), .btn.registration ::slotted(outline-icon[slot='right']){
      margin-left:0.75rem
  }
    }
.btn.tertiary:hover ::slotted(outline-icon[slot='right']), .btn.secondary:hover ::slotted(outline-icon[slot='right']), .btn.primary:hover ::slotted(outline-icon[slot='right']), .btn.primary-2:hover ::slotted(outline-icon[slot='right']), .btn.registration:hover ::slotted(outline-icon[slot='right']){
      transform:translate(0.5rem);
    }
.btn.none{
  padding:0;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-weight:var(--fw-semibold);
  color:var(--brand-primary-2);
  background-color:transparent;
  border:none;
}
.btn.none:focus{
    color:var(--brand-primary-2);
    -webkit-text-decoration-line:underline;
            text-decoration-line:underline;
    outline:solid 2px var(--brand-primary-1) !important;
    border-radius:15px;
    width:-moz-fit-content;
    width:fit-content;
  }
.btn.none[aria-disabled='true']{
    color:var(--brand-neutral-white) !important;
  }
.btn.dropdown{
  border:2px solid var(--brand-neutral-gray-100);
}
.btn.dropdown:focus{
    border:2px solid var(--brand-neutral-white);
    color:var(--brand-primary-1);
  }
.btn.dropdown:focus::after{
    content:'';
    position:absolute;
    padding:0.25rem;
    display:flex;
    border:2px solid var(--brand-neutral-gray-800);
    width:calc(100% + 10px);
    height:calc(100% + 10px);
    left:-5px;
    border-radius:0px;
  }
.btn.dropdown,
.btn.dropdown-alt{
  border-radius:0;
  background-color:var(--brand-neutral-gray-100);
  font-size:var(--fs-base);
  font-weight:var(--fw-medium);
  color:var(--brand-neutral-gray-800);
  width:100%;
  min-width:225px;
  justify-content:space-between;
  padding:1rem 1.25rem;
}
.btn.dropdown:hover, .btn.dropdown-alt:hover{
    background-color:var(--brand-primary-3);
    color:var(--brand-primary-2);
  }
.btn.dropdown:active, .btn.dropdown-alt:active{
    background-color:var(--brand-primary-3) !important;
    border:2px solid var(--brand-primary-3) !important;
  }
.btn.dropdown:active::after, .btn.dropdown-alt:active::after{
      display:none;
    }
.btn.dropdown-alt{
  border:none;
}
.btn.dropdown-alt:focus{
    color:var(--brand-primary-1);
    outline:2px solid black;
  }
.btn.dropdown-nav{
  border-radius:5px;
  background-color:transparent;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-medium);
  color:var(--brand-neutral-gray-800);
  width:max-content;
  border:none;
  margin-top:-2px;
  padding:0 !important;
  z-index:2;
}
.btn.dropdown-nav:focus{
    color:var(--brand-primary-1);
  }
.btn.dropdown-nav:focus::after{
    content:'';
    position:absolute;
    display:flex;
    border:2px solid var(--brand-primary-1);
    width:calc(100% + 10px);
    height:100%;
    left:-6px;
    border-radius:5px;
  }
@media (min-width: 768px) and (max-width: 1023px){
.btn.dropdown-nav{
    line-height:var(--lh-xs);
    font-size:var(--fs-xs)
}
  }
@media (max-width: 767px){
.btn.dropdown-nav{
    margin-top:0;
    justify-content:space-between;
    width:100%
}
  }
`;